import Flickity from 'flickity';

export default class FeaturedMerchants {
  constructor() {
    const $els = document.querySelectorAll('.js-featured-merchants-carousel');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;

    this.flickity = new Flickity($el, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'center',
      contain: true,
      freeScroll: true,
      initialIndex: 2,
      on: {
        ready: () => {
          $el.classList.remove('opacity-0');
        }
      }
    });
  }
}
